import logo from '../../../assets/images/Logo.svg';

export default function Title() {
  return (
    <div className="loginTitle">
      <div className="labelTitle">
        <div>
                Realize seu cadastro
        </div>
        <div className="subtitle">
                Informe os dados a seguir para se cadastrar em nosso sistema.
        </div>
      </div>
      <img src={logo} alt="logo" className="logo" />
    </div>
  );
}
